import { render, staticRenderFns } from "./ShoppingCartLineLabel.vue?vue&type=template&id=bc97d07c"
import script from "./ShoppingCartLineLabel.vue?vue&type=script&lang=ts"
export * from "./ShoppingCartLineLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports